<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="">
        <div class="crumbs">首页 > 全部板块</div>
        <div class="sector-box">
          <div class="sector-ul">
            <div class="sector-li" v-for="(item,index) in sectorList" :key="index">
              <img :src="item.img" alt="img" />
              <div class="sector-text">
                <div class="sector-h">{{item.name}}</div>
                <div class="sector-p">{{item.number}}人在聊</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav},
  data() {
    return {
      selectedIndex: null,
      sectorList: [
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        },
        {
          name: '青光眼',
          number: 1856,
          img: require('@/assets/images/qd4.png'),
        }
      ],
    }
  },
  watch: {
  },
  methods: {
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
  .sector-box{
    background: #fff;
    border-radius: 6px;
    padding: 20px 20px 0 20px;
    margin-top: 22px;
    min-height: 59.5vh;
    margin-bottom: 20px;
  }
  .sector-ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 12px 14px 12px;

    .sector-li:nth-child(4n) {
      margin-right: 0;
    }
    .sector-li:hover{
      background: rgba(164, 18, 24, 0.8);
      .sector-text{
        .sector-h{
          color: #fff;
        }
        .sector-p{
          color: #fff;
        }
      }
    }
    .sector-li {
      background: #F5F5F5;
      width: calc(25% - 4.5px);
      margin-right: 6px;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      padding: 8px 10px;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      .sector-text {
        text-align: left;

        .sector-h {
          color: #171717;
          font-size: 14px;
          line-height: 18px;
        }

        .sector-p {
          color: #404040;
          font-size: 12px;
          line-height: 12px;
          margin-top: 5px;
        }
      }

      img {
        width: 42px;
        height: 42px;
        border-radius: 6px;
        margin-right: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Sector/index.vue